import { Logo } from './Logo'
import { SmoothAnchor } from './SmoothAnchor'
import { CONTACT_EMAIL, CONTACT_LOCATION, CONTACT_PHONE_DISPLAY } from '../lib/contactInfo'

export function Footer() {
  return (
    <footer className="relative border-t border-orb-500/15 bg-gradient-to-b from-transparent to-space-950/60 px-5 pb-8 pt-16 sm:px-8">
      <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-[1.3fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/50">
            Orb Digital.
            <br />
            Tudo gira em torno do resultado.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Navegação</h3>
          <ul className="mt-4 space-y-3 text-sm text-white/50">
            <li><SmoothAnchor href="#servicos" className="transition-colors hover:text-orb-200">Serviços</SmoothAnchor></li>
            <li><SmoothAnchor href="#processo" className="transition-colors hover:text-orb-200">Processo</SmoothAnchor></li>
            <li><SmoothAnchor href="#metodo" className="transition-colors hover:text-orb-200">Método</SmoothAnchor></li>
            <li><SmoothAnchor href="#contato" className="transition-colors hover:text-orb-200">Contato</SmoothAnchor></li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Contato</h3>
          <ul className="mt-4 space-y-3 text-sm text-white/50">
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors hover:text-orb-200">
                {CONTACT_EMAIL}
              </a>
            </li>
            <li>{CONTACT_PHONE_DISPLAY}</li>
            <li>{CONTACT_LOCATION}</li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-7xl flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs text-white/35 sm:flex-row">
        <p>© {new Date().getFullYear()} Orb Digital. Todos os direitos reservados.</p>
        <p>Feito com estratégia e propósito.</p>
      </div>
    </footer>
  )
}
